import { StateCreator } from "zustand"
import { StoreType } from "./AppStore"

export enum TabStatusEnum {
    CRUD = "CRUD",
    VIEW = "VIEW",
    // Terminal de LANÇAMENTO puro (celular do garçom): não assina SSE, não toca, não faz
    // polling, não imprime. O pedido vai ao backend por REST e a estação da loja imprime
    // pela SSE dela. É um estado por-navegador, como VIEW/CRUD.
    GARCOM = "GARCOM",
}

export type TabStatusStoreType = {
    tabStatus: TabStatusEnum
    setTabStatus: (status: TabStatusEnum) => void
}

const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
)

// QZ "configurado" nesta estação, lido de forma SÍNCRONA no boot (antes de o persist do
// zustand reidratar) direto do localStorage cru — a mesma fonte que o app-store persiste.
// Serve para o celular SEM impressora já iniciar em GARCOM, sem abrir e fechar a conexão
// SSE num flicker. Não importa `forcarImpressaoNavegador`/configs do store para evitar
// ciclo de import entre as fatias do AppStore.
const qzConfiguradoLocal = (): boolean => {
    try {
        if (localStorage.getItem("forcarImpressaoNavegador") === "1") return false
        const raw = localStorage.getItem("app-store")
        if (!raw) return false
        const impressoras = JSON.parse(raw)?.state?.configuracoes?.printer?.impressoras
        return Array.isArray(impressoras) && impressoras.length > 0
    } catch {
        return false
    }
}

// Default do 1º load (depois o persist reidrata o valor salvo, se houver):
//  - desktop → CRUD (operação);
//  - celular com QZ → VIEW (acompanha);
//  - celular SEM QZ → GARCOM (só lança). Regra pedida: "Garçom auto-ativa em resolução de
//    celular sem QZ". Celulares que já tinham VIEW persistido são migrados pelo efeito de
//    auto-ativação em OperacaoTempoReal (respeitando escolha manual).
const tabStatusInicial: TabStatusEnum = mobile
    ? qzConfiguradoLocal()
        ? TabStatusEnum.VIEW
        : TabStatusEnum.GARCOM
    : TabStatusEnum.CRUD

const createTabStatusStore: StateCreator<StoreType, [], [], TabStatusStoreType> = (set, get) => {
    return {
        tabStatus: tabStatusInicial,
        setTabStatus: (status: TabStatusEnum) => set({ tabStatus: status }),
    }
}

export default createTabStatusStore
